import React from "react";
import "../../../css/Form.css";
import Select from "react-select";
import TenthComp from "./Tenth";
import OtherEducation from "./OtherEducation";
import EligibilityTest from "./EligibilityTest";
import ERPUtils from "../../../helper/Utils";

const EducationalDetails = (props) => {
  const {
    HighestQualification,
    EducationList,
    EducationDetailsHandler,
    EducationDetailsSelectHandler,
    getBoardOrInstitueList,
    addComponent,
    removeHandler,
    handleRenderComp,
    saveDraft,
    SelectHandler,
    EducationalDetailsDropDownHandler,
    userDetails,
    setUserDetails,
    topFunction,
    scrollToBottom,
    YearsDropDownData,
    requiredFields,
    EligibilityTests,
    EducationStatus,
    GenerateRemovePopup,
    onFileChange,
    imageRemoveHandler,
    openImageInTab,
    ValidationError,
    checkDecimal,
    // dashboardHandler,
    // LockDashboard,
    states,
    countries,
    boardList,
    institutionList,
    EducationOtherDetailsHandler,
    scrollHandler,
    UploadData,
    setSaveTheData
  } = props;

  const onCollapseHandler = (index) => {
    document.getElementById(`qualificationClose${index}`).classList.toggle("collapseClass-forward");
    if (document.getElementById(`qualifcication${index}`) !== null && typeof (document.getElementById(`qualifcication${index}`) !== undefined)) {
      document.getElementById(`qualifcication${index}`).classList.toggle("collapseClass-backward");
    }
  };

  return (
    <div
      className="appForm"
      id="APP-FORM"
      onScroll={scrollHandler}
      style={{
        height:
          window.innerWidth > 800
            ? window.innerHeight - 240
            : window.innerWidth <= 375
            ? window.innerHeight - 275
            : window.innerWidth <= 425
            ? window.innerHeight - 260
            : window.innerHeight - 260,
        overflowY: "auto",
      }}
    >
      <div className="animated zoomIn container-fluid">
        <div className="row p-1">
          <div className="col-sm-6">
            {/* <button
							className={LockDashboard ? 'disabledDashboardBtn' : 'backtoDashboardBtn'}
							onClick={dashboardHandler}
							disabled={LockDashboard}
						>
							<i className="fa fa-arrow-left backIcon" />Back to dashboard
						</button> */}
          </div>
          <div className="col-md-6 col-sm-6">
            <p className="requiredHeader ">
              <span className="requiredTextHeading">*</span> These fields are required
            </p>
          </div>
        </div>
        <div className="row p-1">
          <div className="col-md-4 col-xs-12">
            <label className="appFormLabel">Highest Qualification Level</label>
            <span className="requiredText">*</span>
          </div>
          <div className="col-md-4 col-xs-12">
            <Select
              className={requiredFields.commonErrors[0].HighestQualificationReqError ? "invalid z-depth-3" : "z-depth-3"}
              value={HighestQualification}
              onChange={(selected) => SelectHandler(selected, "HighestQualification")}
              options={EducationList}
            />
            {requiredFields.commonErrors[0].HighestQualificationReqError ? (
              <p className="ValidationError">
                <i className="fa fa-warning warningIcon" />
                Qualification cannot be empty
              </p>
            ) : null}
          </div>
        </div>
        <div className="appDivider" />

        {HighestQualification !== ("" && null)
          ? EducationList.sort((a, b) => parseInt(b.qualificationLevelDegreeOrder) - parseInt(a.qualificationLevelDegreeOrder)).map((el, index) => {
              if (parseInt(el.value, 10) === parseInt(HighestQualification.value, 10)) {
                // el={...el,isMandatory:true}
                var isRequired= true;
              }
              if (parseInt(el.qualificationLevelDegreeOrder, 10) <= parseInt(HighestQualification.qualificationLevelDegreeOrder, 10)) {
                if (ERPUtils.isNullorWhiteSpace(userDetails.EducationDetailsObj[el.value])) {
                  userDetails.EducationDetailsObj[el.value] = [];
                  userDetails.EducationDetailsObj[el.value].push({
                    Qualification: "",
                    Status: "",
                    Course: "",
                    Specialization: "",
                    YearOfComp: "",
                    Percentage: "",
                    Institute: "",
                    Board: "",
                    Documents: [],
                  });
                } else {
                  if (userDetails.EducationDetailsObj[el.value].length === 0) {
                    userDetails.EducationDetailsObj[el.value].push({
                      Qualification: "",
                      Status: "",
                      Course: "",
                      Specialization: "",
                      YearOfComp: "",
                      Percentage: "",
                      Institute: "",
                      Board: "",
                      Documents: [],
                    });
                  }
                }
                return (
                  <div key={index}>
                    <div className="row p-2 border bg-light">
                      <div className="col text-start" id={index + "Qualification"}>
                        {el.label}
                      </div>
                      <div className="col text-right">
                        <i
                          tabIndex={0}
                          className="fas fa-chevron-circle-up room-collapse-icon"
                          id={`qualificationClose${index}`}
                          onClick={() => onCollapseHandler(index)}
                          role="button"
                          aria-hidden="true"
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === "ArrowDown" || event.key === "ArrowUp") {
                              onCollapseHandler(index);
                            }
                          }}
                          aria-label="Collapse Icon"
                        />
                      </div>
                    </div>
                    <div key={index} className="row p-1" id={`qualifcication${index}`}>
                      <TenthComp
                        requiredFields={requiredFields}
                        YearsDropDownData={YearsDropDownData}
                        EducationDetailsHandler={EducationDetailsHandler}
                        getBoardOrInstitueList={getBoardOrInstitueList}
                        EducationDetailsSelectHandler={EducationDetailsSelectHandler}
                        compData={userDetails.EducationDetailsObj[el.value]}
                        userDetails={userDetails}
                        setUserDetails={setUserDetails}
                        addComponent={addComponent}
                        removeHandler={removeHandler}
                        data={el}
                        isRequired={isRequired}
                        EducationalDetailsDropDownHandler={EducationalDetailsDropDownHandler}
                        EducationStatus={EducationStatus}
                        GenerateRemovePopup={GenerateRemovePopup}
                        onFileChange={onFileChange}
                        imageRemoveHandler={imageRemoveHandler}
                        openImageInTab={openImageInTab}
                        ValidationError={ValidationError}
                        checkDecimal={checkDecimal}
                        states={states}
                        countries={countries}
                        boardList={boardList}
                        institutionList={institutionList}
                        UploadData={UploadData}
                        setSaveTheData={setSaveTheData}
                      />
                    </div>
                  </div>
                );
              }
              return "";
            })
          : null}

        {HighestQualification !== "" ? (
          <div className="row p-1">
            <OtherEducation
              userDetails={userDetails}
              setUserDetails={setUserDetails}
              YearsDropDownData={YearsDropDownData}
              others={userDetails.others}
              addComponent={addComponent}
              removeHandler={removeHandler}
              EducationDetailsHandler={EducationDetailsHandler}
              EducationOtherDetailsHandler={EducationOtherDetailsHandler}
              EducationalDetailsDropDownHandler={EducationalDetailsDropDownHandler}
              GenerateRemovePopup={GenerateRemovePopup}
              EducationStatus={EducationStatus}
              onFileChange={onFileChange}
              imageRemoveHandler={imageRemoveHandler}
              openImageInTab={openImageInTab}
              ValidationError={ValidationError}
              checkDecimal={checkDecimal}
              UploadData={UploadData}
              setSaveTheData={setSaveTheData}
            />
            <EligibilityTest
              userDetails={userDetails}
              setUserDetails={setUserDetails}
              Eligibility={userDetails.EligibilityTest}
              YearsDropDownData={YearsDropDownData}
              EducationDetailsHandler={EducationDetailsHandler}
              addComponent={addComponent}
              removeHandler={removeHandler}
              EducationalDetailsDropDownHandler={EducationalDetailsDropDownHandler}
              EligibilityTests={EligibilityTests}
              EducationStatus={EducationStatus}
              GenerateRemovePopup={GenerateRemovePopup}
              onFileChange={onFileChange}
              imageRemoveHandler={imageRemoveHandler}
              openImageInTab={openImageInTab}
              ValidationError={ValidationError}
              UploadData={UploadData}
              setSaveTheData={setSaveTheData}
            />
          </div>
        ) : null}

        <div className="formWrapper">
          <br />
          <div className="row">
            <div className="col-sm-4 parentDiv">
              <button className="PreviousButton z-depthButton" name="AddressDetails" onClick={() => handleRenderComp("AddressDetails")}>
                <i className="fas fa-chevron-left mr-3" style={{ color: "#ffffff" }}></i>
                Previous
              </button>
            </div>
            <div className="col-sm-4 parentDiv">
              <button className="saveDraftButton z-depthButton" name="SaveDraft" onClick={saveDraft}>
                Save Draft
              </button>
            </div>
            <div className="col-sm-4 parentDiv">
              <button className="nextButton z-depthButton" name="ProfessionalExperience" onClick={() => handleRenderComp("ProfessionalExperience")}>
                Next
                <i className="fas fa-chevron-right ml-4 mt-1" style={{ color: "#ffffff" }}></i>
              </button>
            </div>
          </div>
        </div>
        <button onClick={topFunction} id="myBtnUp">
          <div className="UpArrow" />
        </button>
        <button onClick={scrollToBottom} id="myBtnDown">
          <div className="downArrow" />
        </button>
      </div>
    </div>
  );
};

export default EducationalDetails;
